import * as React from 'react'
import { Router, Switch, Route } from 'react-router-dom'
import createHistory from 'history/createBrowserHistory'
import Layout from './Views/Layout/Layout'
import DashboardPage from './Views/Pages/DashboardPage'
import HistoryPage from './Views/Pages/Questionnaire/HistoryPage'
import UsersPage from './Views/Pages/Account/UsersPage'
import UserPage from './Views/Pages/Account/UserPage'
import NotFound from './Views/Pages/NotFound'
import Unauthorized from './Views/Pages/Account/Unauthorized'
import Forbidden from './Views/Pages/Forbidden'
import ServerError from './Views/Pages/ServerError'
import FeedbackPage from './Views/Pages/FeedbackPage'
import QuestionnairesPage from './Views/Pages/Questionnaire/QuestionnairesPage'
import QuestionnairePage from './Views/Pages/Questionnaire/QuestionnairePage'
import LoginPage from './Views/Pages/Account/LoginPage'
import LogoutPage from './Views/Pages/Account/LogoutPage'
import ChangePasswordPage from './Views/Pages/Account/ChangePasswordPage'
import RecoveryPasswordPage from './Views/Pages/Account/RecoveryPasswordPage'
import ResetPasswordPage from './Views/Pages/Account/ResetPasswordPage'
import ConfirmEmailSuccessPage from './Views/Pages/Account/ConfirmEmailSuccessPage'
import ConfirmEmailFailPage from './Views/Pages/Account/ConfirmEmailFailPage'
import ReportsPage from './Views/Pages/Reports/ReportsPage'
import ReportPage from './Views/Pages/Reports/ReportPage'
import TroubleEventsPage from './Views/Pages/TroubleEvent/TroubleEventsPage'
import TroubleEventPage from './Views/Pages/TroubleEvent/TroubleEventPage'
import PaymentsSchedulePage from './Views/Pages/Payment/PaymentsSchedulePage'
import TroubleEventsHistory from './Views/Pages/TroubleEvent/TroubleEventsHistory'
import ExternalDataPage from './Views/Pages/ExternalDataPages/ExternalDataPage'
import ExternalDataSearchPage from './Views/Pages/ExternalDataPages/ExternalDataSearchPage'
import ExternalDataSearchByPinPage from './Views/Pages/ExternalDataPages/ExternalDataSearchByPinPage'
import ExternalDataSearchByCreditNumberPage from './Views/Pages/ExternalDataPages/ExternalDataSearchByCreditNumberPage'
import ExternalDataSearchByPassportPage from './Views/Pages/ExternalDataPages/ExternalDataSearchByPassportPage'
import ExternalCheckPage from './Views/Pages/ExternalDataPages/ExternalCheckPage'
import ExternalDataByNamePage from './Views/Pages/ExternalDataPages/ExternalDataByNamePage'
import ExternalDataByBDayPage from './Views/Pages/ExternalDataPages/ExternalDataByBDayPage'
import CreatePaymentPage from './Views/Pages/Payment/CreatePaymentPage'
import SettingsPage from './Views/Pages/Setting/SettingsPage'
import PaymentCreateSuccessPage from './Views/Pages/Payment/PaymentCreateSuccessPage'
import MerchantsPage from './Views/Pages/Merchant/MerchantsPage'
import AffiliatesPage from './Views/Pages/Affiliate/AffiliatesPage'
import AffiliatePage from './Views/Pages/Affiliate/AffiliatePage'
import MerchantPage from './Views/Pages/Merchant/MerchantPage'
import PaymentsPage from './Views/Pages/Payment/PaymentsPage'
import PaymentPage from './Views/Pages/Payment/PaymentPage'
import CatalogProductsPage from './Views/Pages/CatalogProduct/CatalogProductsPage'
import CatalogProductPage from './Views/Pages/CatalogProduct/CatalogProductPage'
import EditCreditProductsPage from './Views/Pages/Questionnaire/EditCreditProductsPage'
import CreditCommonPage from './Views/Pages/Credit/CreditCommonPage'

export const history = createHistory()

const Routing = () => (
    <Router history={history}>
        <Switch>
            <Route exact path="/reload" />
            <Route exact path="/" render={() => <Layout><DashboardPage /></Layout>} />
            <Route exact path="/dashboard" render={() => <Layout><DashboardPage /></Layout>} />
            <Route exact path="/history" render={() => <Layout><HistoryPage /></Layout>} />
            <Route exact path="/questionnaires" render={() => <Layout><QuestionnairesPage /></Layout>} />
            <Route
                exact
                path="/questionnaire/:id?"
                render={(props) =>
                    <Layout>
                        <QuestionnairePage key={props.match.params.id} />
                    </Layout>
                }
            />

            <Route exact path="/editCreditProducts/:id?" render={() => <Layout><EditCreditProductsPage /></Layout>} />

            <Route exact path="/users" render={() => <Layout><UsersPage /></Layout>} />
            <Route exact path="/user/:id?" render={() => <Layout><UserPage /></Layout>} />
            <Route exact path="/changePassword" render={() => <Layout><ChangePasswordPage /></Layout>} />
            <Route exact path="/confirmEmailSuccess" render={() => <Layout><ConfirmEmailSuccessPage /></Layout>} />
            <Route exact path="/confirmEmailFail" render={() => <Layout><ConfirmEmailFailPage /></Layout>} />
            <Route
                exact
                path="/resetPassword/{0}"
                render={() => <Layout><ResetPasswordPage /></Layout>}
            />
            <Route
                exact
                path="/recoveryPassword/:email/:code"
                render={() => <Layout><RecoveryPasswordPage /></Layout>}
            />
            <Route exact path="/resetPassword" render={() => <Layout><ResetPasswordPage /></Layout>} />
            <Route exact path="/login" render={() => <Layout><LoginPage /></Layout>} />
            <Route exact path="/logout" render={() => <Layout><LogoutPage /></Layout>} />
            <Route exact path="/reports" render={() => <Layout><ReportsPage /></Layout>} />
            <Route
                exact
                path="/reports/:report"
                render={(props) => <Layout><ReportPage key={props.match.params.report} /></Layout>}
            />
            <Route exact path="/troubleevents" render={() => <Layout><TroubleEventsPage /></Layout>} />
            <Route
                exact
                path="/troubleevent/:id"
                render={(props) =>
                    <Layout>
                        <TroubleEventPage key={props.match.params.id} />
                    </Layout>
                }
            />
            <Route exact path="/401" render={() => <Layout><Forbidden /></Layout>} />
            <Route exact path="/403" render={() => <Layout><Unauthorized /></Layout>} />
            <Route exact path="/500" render={() => <Layout><ServerError /></Layout>} />
            <Route exact path="/feedback" render={() => <Layout><FeedbackPage /></Layout>} />
            <Route exact path="/externalData/search" render={() => <Layout><ExternalDataSearchPage /></Layout>} />
            <Route
                exact
                path="/externalData/searchByPin/:pin?"
                render={() =>
                    <Layout>
                        <ExternalDataSearchByPinPage />
                    </Layout>
                }
            />
            <Route
                exact
                path="/externalData/searchByPassport/:passport?"
                render={() => <Layout><ExternalDataSearchByPassportPage /></Layout>}
            />
            {/* <Route 
                exact 
                path="/externalData/searchByPhone/:phone?" 
                render={() => <Layout><ExternalDataSearchByPhonePage /></Layout>}
            /> */}
            <Route
                exact
                path="/externalData/searchByCreditNumber/:creditNumber?"
                render={() => <Layout><ExternalDataSearchByCreditNumberPage /></Layout>}
            />
            <Route
                exact
                path="/externalData/searchByName/:surname/:name"
                render={() => <Layout><ExternalDataByNamePage /></Layout>}
            />
            <Route
                exact
                path="/externalData/searchByBDay/:bDay"
                render={() => <Layout><ExternalDataByBDayPage /></Layout>}
            />
            <Route
                exact
                path="/externalCheck/:questionnaireId"
                render={() => <Layout><ExternalCheckPage /></Layout>}
            />
            <Route
                exact
                path="/paymentsSchedule/:id"
                render={() => <Layout><PaymentsSchedulePage /></Layout>}
            />
            <Route
                exact
                path="/externalData/:phoneNumber?"
                render={() => <Layout><ExternalDataPage /></Layout>}
            />
            <Route
                exact
                path="/troubleEventsHistory"
                render={() => <Layout><TroubleEventsHistory /></Layout>}
            />

            <Route exact path="/payment" render={() => <Layout><CreatePaymentPage /></Layout>} />
            <Route exact path="/payment/:id?" render={() => <Layout><PaymentPage /></Layout>} />
            <Route exact path="/payments" render={() => <Layout><PaymentsPage /></Layout>} />

            <Route exact path="/catalogProduct/:id?" render={() => <Layout><CatalogProductPage /></Layout>} />
            <Route exact path="/catalogProducts" render={() => <Layout><CatalogProductsPage /></Layout>} />

            <Route exact path="/createPaymentSuccess" render={() => <Layout><PaymentCreateSuccessPage /></Layout>} />
            <Route exact path="/settings" render={() => <Layout><SettingsPage /></Layout>} />
            <Route exact path="/merchants" render={() => <Layout><MerchantsPage /></Layout>} />
            <Route exact path="/affiliates" render={() => <Layout><AffiliatesPage /></Layout>} />
            <Route exact path="/affiliate/:id?" render={() => <Layout><AffiliatePage /></Layout>} />
            <Route exact path="/merchant/:id?" render={() => <Layout><MerchantPage /></Layout>} />

            <Route exact path="/credit/:number?" render={() => <CreditCommonPage />} />
            <Route path="*" render={() => <Layout><NotFound /></Layout>} />
        </Switch>
    </Router>
)

export default Routing


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Routing.tsx